import React, { useState, useEffect, useMemo } from 'react';
import { Form, Button, Modal, Alert, Col, Row, Stack, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ProfileFieldBase from './ProfileFieldBase'

import styles from './UserProfile.module.scss'

export default function ProfileFieldOptions({ profileLine, isEditMode, setValue }) {
  const { t } = useTranslation();

  const [id, setId] = useState(profileLine.options.selectedOptionUid);

  useEffect(() => {    
  }, []);

  const handleChange = (event) => {
    setId(event.target.value);

    if (setValue)
      setValue(event.target.value);
  };

  
  return (
    <>
      <ProfileFieldBase profileLine={profileLine} isEditMode={isEditMode}>
        <Form.Select className={styles.input} onChange={handleChange} value={id}>
          {profileLine.options.items.map(line => {
            return (<option value={line.uid} key={line.uid}>{line.displayName}</option>);
          })}
        </Form.Select>
      </ProfileFieldBase>      
    </>
  );
}
